import React from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { formatDisplayDateShort } from "../dateFormat";
import { CELL_WIDTH, CELL_HEIGHT } from "./MatrixCell";

const LINGUIST_COL_WIDTH = 180;

const MatrixHeaderRow = ({ dates }) => (
  <Box sx={{ display: "flex", position: "sticky", top: 0, zIndex: 3, bgcolor: "background.paper" }}>
    <Box
      sx={{
        width: LINGUIST_COL_WIDTH,
        minWidth: LINGUIST_COL_WIDTH,
        height: CELL_HEIGHT,
        position: "sticky",
        left: 0,
        zIndex: 4,
        bgcolor: "grey.100",
        borderRight: "1px solid",
        borderBottom: "2px solid",
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        px: 1,
      }}
    >
      <Typography variant="caption" fontWeight="bold">
        Linguist
      </Typography>
    </Box>
    {dates.map(date => (
      <Box
        key={date}
        sx={{
          width: CELL_WIDTH,
          minWidth: CELL_WIDTH,
          height: CELL_HEIGHT,
          borderRight: "1px solid",
          borderBottom: "2px solid",
          borderColor: "divider",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "grey.100",
        }}
      >
        <Typography variant="caption" fontWeight="bold" lineHeight={1.2}>
          {dayjs(date).format("MMM D")}
          {/* {formatDisplayDateShort(date)} */}
        </Typography>
        <Typography variant="caption" color="text.secondary" lineHeight={1.2}>
          {dayjs(date).format("ddd")}
        </Typography>
      </Box>
    ))}
  </Box>
);

export { LINGUIST_COL_WIDTH };
export default MatrixHeaderRow;
